import * as request from '@/utils/request'
const BASE_URL = '/v1/manage/questionnaire'
export default {
	getQuestionnaireList(data) {
		return request.get(`${BASE_URL}`, data)
	},
    getQuestionnaireInfo(data) {
        return request.get(`${BASE_URL}/view/${data}`)
    },
}
